import Vue from 'vue'
// require('es6-promise').polyfill();
// var axios = require('axios');
import axios from 'axios';
import store from '@/core/store/index';
import iView from 'iview'
import router from '@/router/index'
import global from '@/core/global/global'
var param = global.global.getParam();

let baseURL ="http://pubadmin.cnknowledge.com";
if(location.host.indexOf("dev.") != -1){
 baseURL="http://dev.cnknowledge.com:8081"
}else if (location.host.indexOf(":80") != -1) {
 baseURL="/apis"
}

let ajaxconfig = {
  // 基础url前缀
  baseURL,
  //设置超时时间
  timeout: 300000,
  //返回数据类型
  responseType: 'json', // default
  //请求的接口，在请求的时候，如axios.get(url,config);这里的url会覆盖掉config中的url
  url: '/',

  // 请求方法同上
  method: 'get', // default

  transformRequest: [function(data) {
    // 这里可以在发送请求之前对请求数据做处理，比如form-data格式化等，这里可以使用开头引入的Qs（这个模块在安装axios的时候就已经安装了，不需要另外安装）
    //data = axios.stringify(data);
    ////console.log("data",typeof data,data)
    ////console.log(data.method)
    return data;
  }],

  transformResponse: [function(data) {
    // 这里提前处理返回的数据
    // //console.log(121,data)

    if (typeof data == 'string') {
      data = JSON.parse(data);
    }
    return data;
  }],

  // 请求头信息
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded', //application/json application/x-www-form-urlencoded
  },

  //parameter参数
  params: {},

  //post参数，使用axios.post(url,{},config);如果没有额外的也必须要用一个空对象，否则会报错
  data: {},

  withCredentials: true //当我们把此配置项设置成默认配置项并且设置成true的时候，axios就可以设置cookies了。
};

let instance = axios.create(ajaxconfig);



//请求列表数据

function queryData(options,callBack) {

  var authorization="";//从session中取出token
  if(sessionStorage.getItem("userInfo")){
    var userInfo=JSON.parse(sessionStorage.getItem("userInfo"));//取出sesion
    authorization=userInfo.token;
  }else{
    authorization=""
  }

  //必须基本设置请求参数

  // 发测试使用
  var dev = '/tsg'

  // 本地使用
  // var dev = '';

  let url = dev+options.url || '';
  let method = options.method || ajaxconfig.method; //"get" "post"  "put" ，默认请求get
  let dataType=options.dataType||"";
  let isParseStringJSON = options['jsonString'];

  //扩展基本配置项
  let myConfig = options.baseConfing || {}; //{}

  let config = _.defaultsDeep({}, myConfig);
  config.method = method;
  //获取服务端数据
  if (method == 'post' || method == 'put' || method == 'patch'|| method == 'delete') {

    //POST提交数据时必选参数
    let potsData = options.data || {}; //{firstName: 'Fred',lastName: 'FlintStone'}
    if(method=="post"&&dataType=="formData"){
      callBack(instance);
      return instance[method](url,potsData);
    }

    if (_.isObject(potsData)) {
      if (typeof isParseStringJSON != 'undefined') {
        setAjaxQuestHeader('Content-Type', 'application/json');
        potsData = JSON.stringify(potsData);
      } else {
        setAjaxQuestHeader('Content-Type', 'application/x-www-form-urlencoded');
        potsData = serializeParams(potsData);
      }
    }
    callBack(instance);
    if(method=="delete"){
      potsData={data:potsData};
    }
    // instance.defaults.headers.authorization = param.Authorization||'';
    instance.defaults.headers.Authorization = param.token||'';
    instance.defaults.headers["Zw-Type"]='ajax/json';

    return instance[method].bind(instance, url, potsData, config);
  } else {
    //GET提交数据时必选参数
    let myParams = options.params || {}; //{params: {ID: 12345}} || '/user?ID=12345'
    myParams = Object.assign({}, myParams, {
      // mathRand: Math.random() * 100000000000000000
      time:new Date().getTime()
    });
    config.params = myParams;
    // if(method=="delete"){
    //   instance.defaults.headers.post['Content-Type'] = 'multipart/form-data';
    // }
    callBack(instance);
    // instance.defaults.headers.Token = token;
    // instance.defaults.headers.Client = 'PC';
    // if (typeof isToken != 'undefined') {
    //   instance.defaults.headers.authorization = authorization;
    // }else{
    //   delete instance.defaults.headers.authorization
    // }
    instance.defaults.headers.Authorization =param.token||'';
    instance.defaults.headers["Zw-Type"]='ajax/json';
    return instance[method].bind(instance, url, config);
  }
}

//JSON序列化传入参数形式

function serializeParams(params, type) {
  if (!params) return;
  let obj = {};
  if (type == 'JSON') {
    if (!_.isString(params)) return;
    if (params.indexOf('&') > -1) {
      let splits = params.split('&');
      splits.forEach(function(v, k) {
        let key = v.split('=')[0] || k;
        let val = v.split('=')[1] || undefined;
        obj[key] = val;
      });
      return obj;
    }
  } else {
    if (!_.isObject(params)) {
      if (!_.isObject(JSON.parse(params))) {
        return;
      } else {
        params = JSON.parse(params);
      }
    }
    obj = [];
    _.forEach(params, function(v, k) {
      v = !v ? '' : v;
      let val = k + '=' + v;
      obj.push(val);
    });
    return obj.join('&');
  }
}

//请求前改变请求头源参数
function setAjaxQuestHeader(key, v) {
  ajaxconfig['headers'][key] = v;
  instance = axios.create(ajaxconfig);
}


let ajax = function(option) {
  return queryData(option,function(instance){
    // 拦截器
        //请求响应
        instance.interceptors.request.use(
         config => {
          // //console.log(111,config)
          iView.LoadingBar.start();
          return config
         },
         error => {
            //console.log(error);
         })
        //响应拦截器
        instance.interceptors.response.use(config=> {
          //token 验证失败
          if(config&&config.data){
            if(config.data.resultCode == "1001" || config.data.resultCode == "4001"){
              iView.Message.warning("登录超时，请重新登录");
              setTimeout(function(){
                   console.log(global.global.url+'/logout?Authorization='+param.token||'')
                   window.location.href=global.global.url+'/logout?Authorization='+param.token||'';
              },3000)
              return;
            }
            config.data = config.data||JSON.parse(config.request.responseText);
          }

          iView.LoadingBar.finish();
          return config;
        },error => {
            iView.LoadingBar.finish();
            if(error.response){
              if(error.response.resultCode == 500 || error.response.resultCode == 502){
                 iView.Message.warning("数据加载失败，请稍后再试");
              }else if(error.response.resultCode == 404){
                 iView.Message.warning("数据加载地址请核实");
              }
            }
        });

  })();
};


export default ajax;



// WEBPACK FOOTER //
// ./src/core/api/config/http.js